import React, {Component} from 'react';
import {injectGlobal, ThemeProvider} from 'styled-components';
import {ApolloProvider} from 'react-apollo';
import theme from '../../constants/theme';
import Background from './Background';
import AppNavigation from './AppNavigation';
import client from '../../client';
import 'unfetch/polyfill';

injectGlobal`
    * {
      box-sizing: border-box;
      position:relative;
      font-weight: normal;
      font-style: normal;
      font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
      font-size: ${theme.fontSmall};
      line-height: 1.3;
    }
    body {
      margin: 0;
      padding: 0;
      overflow: hidden;
    }
`;

export default class App extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <ApolloProvider client={client}>
          <Background>
            <AppNavigation />
          </Background>
        </ApolloProvider>
      </ThemeProvider>
    );
  }
}
